<div class="toolbar">
  <button matButton="text" class="toolbarButton" (click)="backToLoopDetail()">
    <span>
      <mat-icon class="size-16">keyboard_backspace</mat-icon>
      <label class="buttonLabel">Back</label>
    </span>
  </button>
  <span class="spacer"></span>
  <button matButton="text" class="toolbarButton" [disabled]="!canSave()" (click)="saveUnit()">
    <span>
      <mat-icon class="size-16">save</mat-icon>
      <label class="buttonLabel">Save</label>
    </span>
  </button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
@if (ratingUnit() && unitData()) {
  <div class="content">
    <app-sure-flow-rating-tool [loop]="loop()?.detail" [ratingUnit]="ratingUnit()" [unitData]="unitData()"
    (performanceChanged)="performanceUpdate($event)"></app-sure-flow-rating-tool>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
